import { useState, useEffect } from "react";
import { Phone, Menu, X, Star } from "lucide-react";
import { Button } from "../components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_chauffage-pac/artifacts/kjcz0m09_ChatGPT%20Image%2011%20fe%CC%81vr.%202026%20a%CC%80%2019_18_47%20%281%29.png";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Nos projets", href: "#realisations" },
  { label: "Avis Google", href: "#avis-google" },
  { label: "Contact", href: "#contact" },
];

export default function Header({ rating = 5, totalReviews = 0 }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const reviewLabel = totalReviews > 0 ? `${rating.toFixed(1)} · ${totalReviews} avis Google` : "5,0 · Avis Google";

  return (
    <header data-testid="site-header" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur-md shadow-md" : "bg-white shadow-sm"}`} style={{ WebkitBackfaceVisibility: "hidden" }}>
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-center justify-between h-14 md:h-18">
          <a href="/" className="flex items-center gap-2 flex-shrink-0" data-testid="logo-link">
            <img src={LOGO_URL} alt="ALTER ENERGIES" className="h-9 md:h-12 w-auto" />
          </a>
          <nav className="hidden md:flex items-center gap-6 lg:gap-8" data-testid="desktop-nav">
            {NAV_LINKS.map((link) => (
              <button key={link.href} onClick={() => handleNavClick(link.href)} className="text-sm font-medium text-gray-700 hover:text-[#6AB023] transition-colors relative after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-[2px] after:bg-[#6AB023] after:transition-all hover:after:w-full" data-testid={`nav-${link.href.slice(1)}`}>
                {link.label}
              </button>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <a href="https://maps.app.goo.gl/C8s7vSJPZ2sHXxe16" target="_blank" rel="noreferrer" className="hidden md:flex items-center gap-1.5 bg-white border border-gray-200 hover:border-[#6AB023] text-gray-700 hover:text-[#6AB023] rounded-full px-4 h-9 text-xs font-semibold transition-all shadow-sm" data-testid="gmb-btn"><Star className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" />{reviewLabel}</a>
            <a href="tel:0628514915" data-testid="header-phone-btn">
              <Button className="bg-[#6AB023] hover:bg-[#5a9a1e] text-white font-semibold rounded-full px-4 md:px-6 h-9 md:h-10 gap-1.5 md:gap-2 text-xs md:text-sm">
                <Phone className="w-3.5 h-3.5 md:w-4 md:h-4" />
                <span className="hidden sm:inline">06 28 51 49 15</span>
                <span className="sm:hidden">Appeler</span>
              </Button>
            </a>
            <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden p-2 text-gray-700 hover:text-[#6AB023] transition-colors" data-testid="mobile-menu-toggle">
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>
      <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${mobileOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0"}`} data-testid="mobile-menu">
        <nav className="bg-white border-t border-gray-100 px-4 py-3 flex flex-col gap-1">
          {NAV_LINKS.map((link) => (
            <button key={link.href} onClick={() => handleNavClick(link.href)} className="text-left py-2.5 px-4 text-gray-700 hover:text-[#6AB023] hover:bg-green-50 rounded-lg font-medium transition-colors text-sm" data-testid={`mobile-nav-${link.href.slice(1)}`}>
              {link.label}
            </button>
          ))}
          <a href="https://maps.app.goo.gl/C8s7vSJPZ2sHXxe16" target="_blank" rel="noreferrer" className="flex items-center gap-1.5 py-2.5 px-4 text-gray-700 hover:text-[#6AB023] hover:bg-green-50 rounded-lg font-medium transition-colors text-sm"><Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />{reviewLabel}</a>
        </nav>
      </div>
    </header>
  );
}
